import React, { useState, useEffect } from 'react';
import { auth } from '../firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';
import logo from '../assets/imgs/bebelogo.png';
import { withErrorHandler } from '../utils/errorHandler';
import { useNotification } from '../components/Notification';
import FormInput from '../components/common/FormInput';
import Button from '../components/common/Button';

const Main = ({ setAuthenticated }) => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  const [email, setEmail] = useState(isDevelopment ? process.env.REACT_APP_DEV_EMAIL || '' : '');
  const [password, setPassword] = useState(isDevelopment ? process.env.REACT_APP_DEV_PASSWORD || '' : '');
  const [error, setError] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { showError, showSuccess } = useNotification();

  // 세션에 로그인 정보가 있으면 로그인 상태로 설정
  useEffect(() => {
    const sessionAuth = sessionStorage.getItem('authenticated');
    if (sessionAuth) {
      setIsLoggedIn(true); // 로컬 상태 true
      setAuthenticated(true); // 전역 인증 상태 true
    }
  }, [setAuthenticated]);

  // 로그인 처리 함수
  const handleLogin = async () => {
    await withErrorHandler(
      async () => {
        // 이메일과 비밀번호로 Firebase 인증 시도
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;

        // 사용자 토큰 가져오기
        const token = await user.getIdToken();

        // 토큰을 세션 스토리지에 저장
        sessionStorage.setItem('token', token);

        // 인증 상태 설정
        setAuthenticated(true);
        setIsLoggedIn(true);

        // 로그인 상태를 세션에 저장
        sessionStorage.setItem('authenticated', 'true');
        
        showSuccess('로그인 성공!');
      },
      {
        onError: (error, errorMessage) => {
          setError(errorMessage);
          setPassword('');
          showError(errorMessage);
        },
        context: { action: 'login', email }
      }
    );
  };

  // 엔터시 로그인
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className="flex items-center justify-center h-[90vh] bg-gray-100">
      {isLoggedIn ? (
        <div className="flex flex-col items-center text-center space-y-4">
          <img src={logo} alt="Admin Logo" className="w-60 h-auto mb-4" />
          <div className="text-gray-700 text-2xl font-bold">Welcome Admin!</div>
        </div>
      ) : (
        <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
          <h2 className="text-gray-700 text-2xl font-semibold text-center mb-6">Welcome Admin Page</h2>
          
          <FormInput
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email"
            error={error && !email ? '이메일을 입력해주세요' : null}
          />
          
          <FormInput
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder="Enter password"
            error={error && !password ? '비밀번호를 입력해주세요' : null}
          />
          
          <Button
            onClick={handleLogin}
            variant="primary"
            size="large"
            fullWidth
            className="mt-6"
          >
            Login
          </Button>
          
          {error && <p className="text-red-500 text-center mt-4">{error}</p>}
        </div>
      )}
    </div>
  );
};

export default Main;